<template>
  <div class="accordion-main-container">
    <mds-section
      v-for="(sectionName, index) in Object.keys(this.dataPointsObj)"
      :key="index"
      class="accordion-section"
      collapsible
      expanded
      container
      :title="dataPointsFieldMap[sectionName]"
      :size="7"
      bold
    >
      <div class="accordion-datapoints-container">
        <div
          v-for="(dataPoint, index) in dataPointsObj[sectionName]"
          :key="'datapoint-index' + index"
          :class="renderDataItemClass(dataPointsObj[sectionName], index)"
        >
          <div class="accordion-datapoint-name">{{ dataPoint.displayName }}</div>
          <div class="accordion-datapoint-field-name">{{ validFieldNameValue(dataPoint) }}</div>
        </div>
      </div>
    </mds-section>
  </div>
</template>

<script>
import MdsSection from '@mds/section';
import { format } from 'date-fns';
import { capitalize } from 'lodash';

const dataPoints = require('@/config/fund-review-panel-datapoints.json');

const mappingDataPointsField = {
  fund_details: 'Fund Details',
  ratings: 'Ratings',
  screens: 'Screens',
  fees: 'Fees',
  ratios: 'Ratios',
  returns: 'Returns',
  assets: 'Assets',
};
export default {
  name: 'fund-review-panel-accordion',
  components: {
    MdsSection,
  },
  data() {
    return {
      dataPointsFieldMap: mappingDataPointsField,
      dataPointsObj: dataPoints,
    };
  },
  props: {
    accordionData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    validFieldNameValue(fieldData) {
      const { fieldName } = fieldData;
      if (fieldName in this.accordionData) {
        const fieldValue = this.accordionData[fieldName];
        if (fieldValue || fieldValue === 0 || fieldValue === false) {
          if (fieldData.format === 'date') {
            return format(new Date(fieldValue), 'MM/DD/YYYY');
          }
          if (fieldData.format === 'capitalize') {
            return capitalize(fieldValue);
          }
          return fieldValue;
        }
      }
      return '--';
    },
    showDivider(data, index) {
      const rowLength = 5;
      if (data.length <= rowLength) {
        return false;
      }
      const modValue = data.length % rowLength;
      if (modValue) {
        return index < data.length - modValue;
      }
      return true;
    },
    renderDataItemClass(data, index) {
      return this.showDivider(data, index) ? 'accordion-datapoint-item item-divider' : 'accordion-datapoint-item';
    },
  },
};
</script>
<style lang="scss">
$medium: 1330px;

.accordion-main-container {
  .accordion-section {
    border: none;
    margin-bottom: $mds-space-half-x;
    .accordion-datapoints-container {
      display: flex;
      width: 100%;
      flex-flow: row wrap;
      position: relative;
      .accordion-datapoint-item {
        flex: 0 0 20%;
        padding: $mds-space-2-x $mds-space-5-x $mds-space-2-x 0;
        &.item-divider {
          border-bottom: 1px solid #ccc;
        }
        .accordion-datapoint-name {
          height: $mds-space-6-x;
          font-weight: $mds-font-weight-regular;
          @media (max-width: $medium) {
            height: $mds-space-8-x;
          }
        }
        .accordion-datapoints-divider {
          border-top: 1px solid #bbb;
          margin-bottom: $mds-space-2-and-a-half-x;
        }
      }
    }
  }
}
</style>
